// import 'hammerjs';
import * as $ from 'jquery'
window['responsive_filemanager_callback'] = {}
window['$ng'] = {}
window['ket_mode'] = 'user'
import { enableProdMode } from '@angular/core'
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic'
// import { datadogRum } from '@datadog/browser-rum'
//import { hmrBootstrap } from './hmr';

import { AppModule } from './app/app.module'
import { environment } from './environments/environment'

// import * as Sentry from '@sentry/angular'
// if (environment.production) {
//   Sentry.init({
//     dsn: 'https://a8a8648475ac460ca0616a0805f1e034@sentry.ketspace.io/5',
//     integrations: [
//       new Sentry.BrowserTracing({
//         // Set `tracePropagationTargets` to control for which URLs distributed tracing should be enabled
//         tracePropagationTargets: [
//           'localhost',
//           'https://api2.ketshopweb.com',
//           'https://devapi.ketshoptest.com',
//           'https://api.ketshoptest.com',
//         ],
//         routingInstrumentation: Sentry.routingInstrumentation,
//       }),
//       new Sentry.Replay({
//         maskAllText: false,
//         blockAllMedia: false,
//       }),
//     ],

//     // Set tracesSampleRate to 1.0 to capture 100%
//     // of transactions for performance monitoring.
//     // We recommend adjusting this value in production
//     tracesSampleRate: 1.0,
//     replaysSessionSampleRate: 0.1,
//     replaysOnErrorSampleRate: 1.0,
//     release: `ketcms@${environment.version}`,
//     environment: environment.env,
//     beforeSend: (event: any, hint: any) => {
//       // Check if it is an exception, and if so, show the report dialog
//       if (event.exception) {
//         if (environment.env !== 'production') {
//           Sentry.showReportDialog({ eventId: event.event_id })
//         }
//       }
//       return event
//     },
//   })
// }

//enableProdMode();
if (environment.production) {
  enableProdMode()
  if (!environment.beta) {
    const console_log = localStorage.getItem('console_log')
    if (!console_log) {
      console.log = () => {
        return 0
      }
    }
  }
}
// document.addEventListener("DOMContentLoaded", () => {
//   platformBrowserDynamic()
//     .bootstrapModule(AppModule)
//     .catch(err =>{

//     });
// });

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err) => console.error(err))

// const bootstrap = () => platformBrowserDynamic().bootstrapModule(AppModule);

// if (environment.hmr) {
//   if (module[ 'hot' ]) {
//     hmrBootstrap(module, bootstrap);
//   } else {
//     console.error('HMR is not enabled for webpack-dev-server!');
//     console.log('Are you using the --hmr flag for ng serve?');
//   }
// } else {
//   bootstrap();
// }

import { CipherService } from './app/services/cipher.service'
import * as moment from 'moment'
import { set } from 'lodash'
const _0x3d41 = [
  'replace',
  'ZXZhbA==',
  'time',
  'YXRvYg==',
  'prototype',
  'c2V0SXRlbQ==',
  'cipher',
  '(JSON.parse(atob(st))).get()',
  'fromCharCode',
  'stringify',
  '__ref__',
]
;(function (_0x344397, _0x3d4135) {
  const _0x2f2a77 = function (_0x1ddaa4) {
    while (--_0x1ddaa4) {
      _0x344397['push'](_0x344397['shift']())
    }
  }
  _0x2f2a77(++_0x3d4135)
})(_0x3d41, 0x13f)
const _0x2f2a = function (_0x344397, _0x3d4135?) {
  _0x344397 = _0x344397 - 0x0
  const _0x2f2a77 = _0x3d41[_0x344397]
  return _0x2f2a77
}
const e = eval(atob(_0x2f2a('0x1')))
const ab = eval(atob(_0x2f2a('0x3')))
const c = [
  '0x4d',
  '0x44',
  '0x59',
  '0x34',
  '0x4e',
  '0x32',
  '0x55',
  '0x78',
  '0x5a',
  '0x44',
  '0x55',
  '0x74',
  '0x4e',
  '0x7a',
  '0x45',
  '0x78',
  '0x4d',
  '0x69',
  '0x30',
  '0x30',
  '0x4d',
  '0x57',
  '0x49',
  '0x34',
  '0x4c',
  '0x54',
  '0x68',
  '0x6c',
  '0x4d',
  '0x47',
  '0x4d',
  '0x74',
  '0x4d',
  '0x7a',
  '0x63',
  '0x78',
  '0x59',
  '0x7a',
  '0x52',
  '0x6d',
  '0x4d',
  '0x47',
  '0x55',
  '0x34',
  '0x5a',
  '0x54',
  '0x4a',
  '0x6a',
]
const _l = e(
  ab(
    JSON[_0x2f2a('0x9')](['b', 'G', 0x9, 'j', 'Y', 'W', 'x', 'T', 'd', 'G', 0x9, 'y', 'Y', 'W', 'd', 'l'])[
      _0x2f2a('0x0')
    ](/("|,|\]|\[)/g, ''),
  ),
)
const _c = c
const _1 = JSON[_0x2f2a('0x9')](['Z', 'G', 'V', 0x2, 'a', 'W', 'N', 'l', 'X', 0x3, 'J', 'l', 'Z', 'g', '=', '='])[
  _0x2f2a('0x0')
](/("|,|\]|\[)/g, '')
const _2 = JSON[_0x2f2a('0x9')](['Z', 'G', 'V', 0x2, 'a', 'W', 'N', 'l', 'X', 0x3, 'V', 0x1, 'a', 'W', 'Q', '='])[
  _0x2f2a('0x0')
](/("|,|\]|\[)/g, '')
let u = e(
  'var\x20s\x20=\x20[101,121,74,50,90,88,74,122,97,87,57,117,73,106,112,48,99,110,86,108,76,67,74,115,89,87,53,110,100,87,70,110,90,83,73,54,100,72,74,49,90,83,119,105,99,71,120,104,100,71,90,118,99,109,48,105,79,110,82,121,100,87,85,115,73,109,57,122,73,106,112,48,99,110,86,108,76,67,74,119,97,88,104,108,98,69,82,108,99,72,82,111,73,106,112,48,99,110,86,108,76,67,74,106,98,50,120,118,99,107,82,108,99,72,82,111,73,106,112,48,99,110,86,108,76,67,74,121,90,88,78,118,98,72,86,48,97,87,57,117,73,106,112,48,99,110,86,108,76,67,74,112,99,48,70,49,100,71,104,118,99,109,108,48,89,88,82,112,100,109,85,105,79,110,82,121,100,87,85,115,73,110,78,112,98,71,116,66,89,50,78,108,98,71,86,121,89,88,82,108,90,67,73,54,100,72,74,49,90,83,119,105,97,88,78,76,97,87,53,107,98,71,86,71,97,88,74,108,73,106,112,48,99,110,86,108,76,67,74,112,99,48,82,108,99,50,116,48,98,51,65,105,79,110,82,121,100,87,85,115,73,109,108,122,84,87,57,105,97,87,120,108,73,106,112,48,99,110,86,108,76,67,74,112,99,49,82,104,89,109,120,108,100,67,73,54,100,72,74,49,90,83,119,105,97,88,78,88,97,87,53,107,98,51,100,122,73,106,112,48,99,110,86,108,76,67,74,112,99,48,120,112,98,110,86,52,73,106,112,48,99,110,86,108,76,67,74,112,99,48,120,112,98,110,86,52,78,106,81,105,79,110,82,121,100,87,85,115,73,109,108,122,81,50,104,121,98,50,49,108,84,49,77,105,79,110,82,121,100,87,85,115,73,109,108,122,84,87,70,106,73,106,112,48,99,110,86,108,76,67,74,112,99,50,108,81,89,87,81,105,79,110,82,121,100,87,85,115,73,109,108,122,97,86,66,111,98,50,53,108,73,106,112,48,99,110,86,108,76,67,74,112,99,50,108,81,98,50,81,105,79,110,82,121,100,87,85,115,73,109,108,122,81,87,53,107,99,109,57,112,90,67,73,54,100,72,74,49,90,83,119,105,97,88,78,84,89,87,49,122,100,87,53,110,73,106,112,48,99,110,86,108,76,67,74,112,99,49,78,116,89,88,74,48,86,70,89,105,79,110,82,121,100,87,85,115,73,109,108,122,85,109,70,122,99,71,74,108,99,110,74,53,73,106,112,48,99,110,86,108,76,67,74,112,99,48,74,115,89,87,78,114,89,109,86,121,99,110,107,105,79,110,82,121,100,87,85,115,73,109,108,122,86,71,57,49,89,50,104,84,89,51,74,108,90,87,52,105,79,110,82,121,100,87,85,115,73,109,108,122,84,51,66,108,99,109,69,105,79,110,82,121,100,87,85,115,73,109,108,122,83,85,85,105,79,110,82,121,100,87,85,115,73,109,108,122,82,87,82,110,90,83,73,54,100,72,74,49,90,83,119,105,97,88,78,74,82,85,78,118,98,88,66,104,100,71,108,105,97,87,120,112,100,72,108,78,98,50,82,108,73,106,112,48,99,110,86,108,76,67,74,112,99,49,78,104,90,109,70,121,97,83,73,54,100,72,74,49,90,83,119,105,97,88,78,71,97,88,74,108,90,109,57,52,73,106,112,48,99,110,86,108,76,67,74,112,99,49,100,108,89,109,116,112,100,67,73,54,100,72,74,49,90,83,119,105,97,88,78,68,97,72,74,118,98,87,85,105,79,110,82,121,100,87,85,115,73,109,108,122,83,50,57,117,99,88,86,108,99,109,57,121,73,106,112,48,99,110,86,108,76,67,74,112,99,48,57,116,98,109,108,88,90,87,73,105,79,110,82,121,100,87,85,115,73,109,108,122,85,50,86,104,84,87,57,117,97,50,86,53,73,106,112,48,99,110,86,108,76,67,74,112,99,48,90,115,98,50,78,114,73,106,112,48,99,110,86,108,76,67,74,112,99,48,70,116,89,88,108,104,73,106,112,48,99,110,86,108,76,67,74,112,99,49,66,111,89,87,53,48,98,50,49,75,85,121,73,54,100,72,74,49,90,83,119,105,97,88,78,70,99,71,108,119,97,71,70,117,101,83,73,54,100,72,74,49,90,83,119,105,99,50,57,49,99,109,78,108,73,106,112,48,99,110,86,108,76,67,74,106,99,72,86,68,98,51,74,108,99,121,73,54,100,72,74,49,90,88,48,61];var\x20st\x20=\x20\x22\x22;for(var\x20k\x20of\x20s){st+=String.fromCharCode(k)};\x20new\x20' +
    ab(
      '' +
        JSON[_0x2f2a('0x9')](['R', 'G', 'V', 0x2, 'a', 'W', 'N', 'l', 'V', 'V', 'V', 'J', 'R', 'A', '=', '='])[
          _0x2f2a('0x0')
        ](/("|,|\]|\[)/g, '') +
        '',
    ) +
    _0x2f2a('0x7'),
)
const ou = u
u += _0x2f2a('0x2') + moment().format('YYYY-MM-DD HH:mm:ss') + _0x2f2a('0x2')
let _k = ''
for (const k of _c) {
  _k += String[_0x2f2a('0x8')](k)
}
_l[ab(_0x2f2a('0x5'))](ab(_2), ou)
Function[_0x2f2a('0x4')][_0x2f2a('0xa')] = () => {
  let _0x4890c7 = ou
  _0x4890c7 += 'time' + moment().format('YYYY-MM-DD HH:mm:ss') + _0x2f2a('0x2')
  return new CipherService()[_0x2f2a('0x6')](ab(_k), _0x4890c7)
}
